import { Link } from "react-router-dom";

import notebook from "../../../assets/img/notebook-payment-mobile.webp";
import bankIcon from "../../../assets/icons/bank.svg";
import returnIcon from "../../../assets/icons/return.svg";
import searchIcon from "../../../assets/icons/search.svg";
import paperIcon from "../../../assets/icons/paper.svg";

export default function Payment({ tab }) {
  return (
    <div
      className={
        tab !== "tab1"
          ? "hidden"
          : "flex md:flex-row flex-col xl:h-150 items-center md:justify-between md:items-start relative lg:mx-8 xl:mx-0 sm:mx-0"
      }
    >
      <div className="text-white md:mt-12 mt-4 xl:w-[590px] md:w-[340px] w-[300px] mb-10 flex flex-col items-center md:items-start 2xl:ml-12">
        <h2 className="font-bold xl:text-3xl text-lg mb-5 xl:w-[520px] md:w-[300px]">
          Automatize todos os pagamentos, com agilidade e segurança.
        </h2>
        <p className="md:text-[15px] xl:text-xl text-xs xl:w-[590px] md:w-[310px]">
          Gerenciamento de todos os pagamentos em uma única plataforma com opção
          multibanco e multiempresa que integra com seu ERP.
        </p>
        <img
          src={notebook}
          alt="Notebook aberto com Inncash na tela"
          className="xl:mt-10 mt-6 xl:ml-5 xl:w-[400px] md:w-[280px]"
        />
      </div>

      <div className="flex flex-col justify-center -mt-48 md:mt-0 md:-ml-3">
        <div className="mt-44 md:mt-10 flex flex-col justify-center items-center">
          <h2 className="md:text-xl text-lg mb-5 text-white">
            Com o <strong>InnCash</strong>, você tem:
          </h2>
        </div>
        <div className="grid grid-cols-2 gap-2 max-[380px]:gap-1 xl:gap-5 md:gap-4">
          <span className="xl:w-75 xl:h-43 md:w-[225px] md:h-[130px] w-[177px] max-[380px]:w-[167px] h-[120px] bg-white rounded-2xl text-blue-inncash font-medium flex flex-col items-center justify-center">
            <img
              src={bankIcon}
              alt="Ícone banco azul"
              className="md:mb-2 mb-2 w-[35px] md:w-[50px]"
            />
            <p className="xl:text-[18px] md:text-[14px] text-[11px]">
              Pagamentos de títulos
            </p>
            <p className="xl:text-[18px] md:text-[14px] text-[11px]">
              (TED, PIX, Boleto, Impostos
            </p>
            <p className="xl:text-[18px] md:text-[14px] text-[11px]">
              e Concessionárias)
            </p>
          </span>
          <span className="xl:w-75 xl:h-43 md:w-[225px] md:h-[130px] w-[177px] max-[380px]:w-[167px] h-[120px] bg-white rounded-2xl text-blue-inncash font-medium flex flex-col items-center justify-center">
            <img
              src={returnIcon}
              alt="Ícone azul de papel com retorno "
              className="md:mb-5 mb-2 w-[25px] md:w-[36px] xl:w-[40px]"
            />
            <p className="xl:text-[18px] md:text-[14px] text-[11px]">
              Processamento de retornos
            </p>
            <p className="xl:text-[18px] md:text-[14px] text-[11px]">
              bancários e envio por e-mail
            </p>
          </span>
          <span className="xl:w-75 xl:h-43 md:w-[225px] md:h-[130px] w-[177px] max-[380px]:w-[167px] h-[120px] bg-white rounded-2xl text-blue-inncash font-medium flex flex-col items-center justify-center">
            <img
              src={searchIcon}
              alt="Ícone lupa azul"
              className="md:mb-5 mb-2 w-[35px] md:w-[45px] xl:w-[50px]"
            />
            <p className="xl:text-[18px] md:text-[14px] text-[11px]">
              Conciliação automática de
            </p>
            <p className="xl:text-[18px] md:text-[14px] text-[11px]">
              boletos com DDA bancário
            </p>
          </span>
          <span className="xl:w-75 xl:h-43 md:w-[225px] md:h-[130px] w-[177px] max-[380px]:w-[167px] h-[120px] bg-white rounded-2xl text-blue-inncash font-medium flex flex-col items-center justify-center">
            <img
              src={paperIcon}
              alt="Ícone de papel azul"
              className="md:mb-5 mb-2 w-[25px] md:w-[36px] xl:w-[40px]"
            />
            <p className="xl:text-[18px] max-[380px]:text-[11px] md:text-[14px] text-[11px]">
              Geração de faturas em lote para
            </p>
            <p className="xl:text-[18px] max-[380px]:text-[11px] md:text-[14px] text-[11px]">
              pagamento em um único boleto
            </p>
          </span>
          <button className="rounded-3xl bg-green-500-attention transition duration-150 hover:bg-green-500-attention-hover text-white md:py-3 py-1 md:text-[13px] text-[11px] mt-1 font-bold">
            <Link to="/solucoes-em-pagamentos">SAIBA MAIS</Link>
          </button>
          <button className="rounded-3xl bg-green-500-attention transition duration-150 hover:bg-green-500-attention-hover text-white md:py-3 py-1 md:text-[13px] text-[11px] mt-1 font-bold">
            <a href="#contact-section">SOLICITAR DEMONSTRAÇÃO</a>
          </button>
        </div>
      </div>
    </div>
  );
}
